import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { ENUM_CATEGORY, ENUM_COKITCHEN_STATUS, ENUM_COKITCHEN_TYPE } from 'utils/enum';
import { ArrowRightIcon } from 'cokitchen-icons';
import { ROUTE_KEYS, ROUTE_PREFIX, STORAGE_KEYS } from 'utils/constants';

const CokitchenDropdown = () => {
  const navigate = useNavigate();
  const {
    activeCokitchen,
    setActiveCokitchen,
    cokitchens,
    category,
    setIsFcb,
    isFcb,
    permissions
  } = useDashboardContext();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleCategoryChange = (item: ENUM_CATEGORY) => {
    const routePrefix = item === ENUM_CATEGORY.FOOD ? ROUTE_PREFIX.FOOD : ROUTE_PREFIX.SHOP;
    setShowDropdown(false);
    localStorage.setItem(STORAGE_KEYS.CATEGORY, item);
    window.location.href = `${routePrefix}/${ROUTE_KEYS.OVERVIEW}`;
  };
  const navigateToPopupKitchens = () => {
    navigate(`${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.KITCHEN_LIST}`);
  };
  const navigateToDineInKitchens = () => {
    navigate(`${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.DINE_IN_LIST}`);
  };
  const disableDropDown = !permissions.canAccessCreateList;

  return (
    <Dropdown
      visible={showDropdown}
      disabled={disableDropDown}
      onClickOutside={() => setShowDropdown(false)}
      content={
        <div className='sidebar_top'>
          <div>
            <p
              onClick={() => setShowDropdown(!showDropdown)}
              className='text-gray-6 font-medium text-sm min-h-[20px]'>
              {isFcb ? 'FoodCourt Business' : activeCokitchen?.name ?? '--'}
            </p>
            {/* Comment out later */}
            <ul className='category_box '>
              {[ENUM_CATEGORY.FOOD, ENUM_CATEGORY.SHOP].map((item) => (
                <button
                  disabled={disableDropDown}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCategoryChange(item);
                  }}
                  key={item}
                  className={`cursor-pointer category_box--item ${
                    category === item ? 'is-active' : ''
                  }`}>
                  {item}
                </button>
              ))}
            </ul>
          </div>
          <span className='dropdown-content' onClick={() => setShowDropdown(!showDropdown)}>
            ^
          </span>
        </div>
      }>
      <DropdownList>
        {cokitchens
          .filter(
            ({ cokitchen_type }) =>
              cokitchen_type !== ENUM_COKITCHEN_TYPE.POP &&
              cokitchen_type !== ENUM_COKITCHEN_STATUS.DINE_IN
          )
          ?.map((kitchen) => (
            <DropdownItem
              key={kitchen.id}
              onClick={() => {
                setActiveCokitchen(kitchen);
                setShowDropdown(false);
                setIsFcb(false);
              }}>
              <p className='text-gray-6 font-medium text-sm'>{kitchen.name}</p>
            </DropdownItem>
          ))}
        <DropdownItem>
          <div
            className='flex justify-between items-center w-full gap-6 text-gray-6 font-medium text-sm'
            onClick={() => {
              navigateToPopupKitchens();
              setShowDropdown(!showDropdown);
              setIsFcb(false);
            }}>
            <div className='flex justify-between items-center w-full gap-6 text-gray-6 text-sm'>
              Pop-up Kitchens
              <ArrowRightIcon />
            </div>
          </div>
        </DropdownItem>
        <DropdownItem>
          <div
            className='flex justify-between items-center w-full gap-6 text-gray-6 font-medium text-sm'
            onClick={() => {
              navigateToDineInKitchens();
              setShowDropdown(!showDropdown);
              setIsFcb(false);
            }}>
            <div className='flex justify-between items-center w-full gap-6 text-gray-6 text-sm'>
              Dine-in Kitchens
              <ArrowRightIcon />
            </div>
          </div>
        </DropdownItem>
        <DropdownItem>
          <div
            className='flex justify-between items-center w-full gap-6 text-gray-6 font-medium text-sm'
            onClick={() => {
              setIsFcb(true);
              setShowDropdown(false);
            }}>
            <div className='flex justify-between items-center w-full gap-6 text-gray-6 text-sm'>
              FoodCourt Business
              <ArrowRightIcon />
            </div>
          </div>
        </DropdownItem>
      </DropdownList>
    </Dropdown>
  );
};

export default CokitchenDropdown;
